import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../../core/service/base/his-ui.service';
/** Einzelne Content-Komponente der gesamten Helptext-Komponente.
  * Der Content zeigt je nach Zustand unterschiedliche Titel, Untertitel und Inhalte an, die über die Inputs gesteuert werden.
  * Kann für eine aufgeteilte Nutzung von Helptext-Button und Helptext-Content verwendet werden, siehe Beispiel in der HisPanelHelptextDirective.
  */
@Component( {
    selector: 'his-helptext-content',
    templateUrl: './his-helptext-content.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisHelptextContentComponent {
    private readonly hisUi = inject( HisUiService );
    /** Titel des Hilfetextes. */
    readonly title = input<string>( this.hisUi.translate( 'common.help' ) );
    /** Untertitel des Hilfetextes. */
    readonly subtitle = input.required<string>();
    /** Inhalt des Hilfetextes. */
    readonly helptext = input.required<string>();
    /** Gibt an, ob der Hilfetext angezeigt wird. */
    readonly displayHelptext = input.required<boolean>();
}